import './section-title.css';

const SectionTitle = ({border, children, ...props}) => (
  <div {...props} className={`section-title ${props.className}`}>
    <h4 className="text-uppercase">
      {children}
    </h4>
  </div>
);

export default SectionTitle;
